// extracted by mini-css-extract-plugin
export var footer = "_se-0";
export var inherit = "_se-1";
export var input = "_se-2";
export var modalContent = "_se-3";
export var quillEditor = "_se-4";
export var subtitle = "_se-5";